import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { urlWMSInundaciones, formatoPNG } from './configuracion';

const layer00331 = new TileLayer({
  title: 'Máscara 19971016',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19971016l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00331.setVisible(false);

const layer00330 = new TileLayer({
  title: 'Máscara 19980309',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19980309l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00330.setVisible(false);

const layer00329 = new TileLayer({
  title: 'Máscara 19980325',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19980325l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00329.setVisible(false);

const layer00328 = new TileLayer({
  title: 'Máscara 19980613',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19980613l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00328.setVisible(false);

const layer00327 = new TileLayer({
  title: 'Máscara 19980715',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19980715l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00327.setVisible(false);

const layer00326 = new TileLayer({
  title: 'Máscara 19980816',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '19980816l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00326.setVisible(false);

export const grupoCapa01_24 = new LayerGroup({
  title: 'Ciclo Hidrológico 1997-1998',
  fold: 'close',
  layers: [layer00326, layer00327, layer00328, layer00329, layer00330, layer00331]
});